import PropTypes from 'prop-types'
import {Button} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {useRails} from '~/react/contexts/rails'
import {DownloadIcon} from '~/react/icons/DownloadIcon'

const DownloadMCoinFeeTaxInvoiceButton = ({paymentId}) => {
  const {t} = useTranslation('pointsOnPayments')
  const {currentSupplier} = useRails()

  const href = `/points_on_payments/api/suppliers/${currentSupplier.id}/payments/${paymentId}/mcoin_fee_tax_invoice`

  return (
    <Button
      as="a"
      alignSelf="flex-start"
      variant="secondary"
      href={href}
      leftIcon={<DownloadIcon />}
    >
      {t('pointsOnPayments:pointsOnPayment.drawer.downloadMcoinFeeTaxInvoice')}
    </Button>
  )
}

DownloadMCoinFeeTaxInvoiceButton.propTypes = {
  paymentId: PropTypes.string.isRequired,
}

export default DownloadMCoinFeeTaxInvoiceButton
